import { render, staticRenderFns } from "./formFile.vue?vue&type=template&id=67683440&"
import script from "./formFile.vue?vue&type=script&lang=js&"
export * from "./formFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports